// extracted by mini-css-extract-plugin
module.exports = {"root":"TemplateDetails_root__2e5bo"};